import DealInfo from "./DealInfo";

export default function DealsByType({ error, loading, ...data }) {
  return {
    dealsInfo: new DealInfo(data?.agent_listings ?? {}),
    hasError: Boolean(error),
    isLoading: loading
  };
}

DealsByType.PAGE_SIZE = 6;
